const meta = {
  'prometheus-agent': {
    display: 'hidden',
  },
};

export default meta;
